var React = require('react');
var LoginStore = require('../../stores/LoginStore.js');
var LoginActions = require('../../actions/LoginActions.js');
var ErrorCodes = require('../../utils/ErrorCodes.js');
var LocaleUtils = require('../../utils/localeUtils.js');
var defaultMessages = require('../../i18n/messages/default.js');
var Utils = require('../../utils/Utils.js');
var UrlUtils = require('../../utils/urlUtils');
// TODO : change loginhelper incase there is only one function or else add all relevant functions there
var LoginHelper = require('../../utils/loginHelper');
var OAuthClientConfig = require('../../LPAuthUtils/OAuthClientConfig');
var AppConstants = require('../../constants/AppConstants');
const Cookies = require('js-cookie');

var {isNil} = require('lodash');
class LoginHandler extends React.Component {
    constructor(props) {
        super(props);
        this.onLoginChange = this.onLoginChange.bind(this);
        this.onSamlLoginChange = this.onSamlLoginChange.bind(this);
        this.onLoginWithPasscodeChange = this.onLoginWithPasscodeChange.bind(this);
    }
    
    componentDidMount() {
        LoginStore.addLoginChangeListener(this.onLoginChange);
        LoginStore.addSamlLoginChangeListener(this.onSamlLoginChange);
        LoginStore.addLoginWithPasscodeListener(this.onLoginWithPasscodeChange);
    }

    componentWillUnmount() {        
        LoginStore.removeLoginChangeListener(this.onLoginChange);
        LoginStore.removeSamlLoginChangeListener(this.onSamlLoginChange);
        LoginStore.removeLoginWithPasscodeListener(this.onLoginWithPasscodeChange);
    }

    onLoginChange() {
        let appState = LoginStore.getState();
        function containsLetterOrAt(loginIdType) {
            return /[a-zA-Z@]/.test(loginIdType);
        }

        if (appState.AuthCode.result == "Authenticated") {
            Utils.googleAnalyticsClickEvents('login','authorisation', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false );
            //set gtm datalayer object with logged-in true
            let props = this.props;
            Utils.setGADatalayer(props.countryCode, this.props.localeId, props.userType, props.realmId, props.clientId, props.redirectUrl, true);
            const redirecturi = appState.AuthCode.redirecturi;
            let idToken = UrlUtils.getHashParameterbyName('id_token', redirecturi);
            // gets the authentication methods for a user
            LoginActions.getUserMFAMethods(idToken, props.countryCode);
            this.handleRedirection(redirecturi, props, false);
        }
        else if (appState.AuthCode.result == "Non Authenticated" || appState.AuthCode.result == "CSRF token invalid, expired or missing") {
            if (["0201001","0201002","0201003","0201004","0201005",
                "0201006","0201007","0201008","0201009", "0201022"].includes(appState.AuthCode.message)) {
                const errorCode = ErrorCodes[appState.AuthCode.message] + '_' + this.props.userType + '_' + this.props.countryCode;
                let messageKey = ErrorCodes[appState.AuthCode.message];
                let title = null;

                if (LocaleUtils.isTranslationIdAvailable(this.props.intl, defaultMessages, errorCode)) {
                    messageKey = errorCode;
                    title = appState.AuthCode.message == "0201009" && this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.AuthCode.message]]);
                }
                let analyticsErrors ={
                    type: this.props.intl.formatMessage(defaultMessages[messageKey]),
                    label:appState.AuthCode.result,
                }

                Utils.googleAnalyticsClickEvents('errors','', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false, false, analyticsErrors );

                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[messageKey]), 'error', false, title);
                this.props.setState({loginError: appState.AuthCode.message});
            }
            else if("0201023" === appState.AuthCode.message){
                const isClientPasswordless = UrlUtils.getParameterByName("passwordless") === 'true';
                const allowedCookies = Cookies.get('allowedCookieCategories') || 'performance';
                let messageToasterPasswordless = containsLetterOrAt(this.props.loginId) ? this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.AuthCode.message]]) : this.props.intl.formatMessage(defaultMessages["passwordlessSmsNotification"]);
                Utils.googleAnalyticsClickEvents('login','authorisation', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false, true );
                LoginActions.triggerToast(messageToasterPasswordless, 'success');
                this.props.setState({loginError: ''});
                if(isClientPasswordless && allowedCookies.includes('performance')){
                    Utils.loadQualtrics(100, "r", "click")
                }
            }
            else if("0201028" === appState.AuthCode.message){
                let isEmail =containsLetterOrAt(this.props.loginId);
                let messageToasterForceR = isEmail ? this.props.intl.formatMessage(defaultMessages['emailSentForceResetPass']) : this.props.intl.formatMessage(defaultMessages['smsSentForceResetPass']);
                const forgotChannelMethod = isEmail ? AppConstants.UrlParams.EMAIL : AppConstants.UrlParams.MOBILE;
                LoginActions.submitForgotPassword(this.props.loginId, this.props, forgotChannelMethod);
                LoginActions.triggerToast(messageToasterForceR, "warning");
            }
            else {
                let analyticsErrors ={
                    type: this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.AuthCode.message]] || defaultMessages[appState.AuthCode.message]),
                    label: appState.AuthCode.message,
                }
                Utils.googleAnalyticsClickEvents('errors','', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false, false, analyticsErrors );

                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.AuthCode.message]] || defaultMessages[appState.AuthCode.message]), "error");
                this.props.setState({loginError: appState.AuthCode.message});
            }
        }
        else if(appState.AuthCode.result === "Failed captcha challenge") {
            let analyticsErrors ={
                type: this.props.intl.formatMessage(defaultMessages['error.failed.captcha']),
                label: "Failed captcha challenge",
            }

            Utils.googleAnalyticsClickEvents('errors','', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false, false, analyticsErrors );

            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['error.failed.captcha']), 'error');
        }
        else if(appState.AuthCode.result === "Too many failed attempts") {
            let analyticsErrors ={
                type: this.props.intl.formatMessage(defaultMessages['error.failed.too_many_attempts']),
                label: "Too many failed attempts",
            }
            Utils.googleAnalyticsClickEvents('errors','', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false, false, analyticsErrors );

            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['error.failed.too_many_attempts']), 'error');
        }
        else if (appState.AuthCode.result && appState.AuthCode.result.status === 400) {
            window
                .location
                .replace(appState.AuthCode.redirecturi)
        }
            else {
            let analyticsErrors ={
                type: this.props.intl.formatMessage(defaultMessages['invalid_credentials']),
                label: "Invalid Credentials",
            }
            Utils.googleAnalyticsClickEvents('errors','', this.props.countryCode, 'Login' , this.props.userType, this.props.reamlId, this.props.clientId, false, false, analyticsErrors );
            
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['invalid_credentials']), "error");
            this.props.setState({loginError: 'invalid_credentials'});
        }
    }

    onLoginWithPasscodeChange() {
        let appState = LoginStore.getState();
        if (appState.AuthCode.result == "Authenticated") {
            //set gtm datalayer object with logged-in true
            var props = this.props;
            Utils.setGADatalayer(props.countryCode, this.props.localeId, props.userType, props.realmId, props.clientId, props.redirectUrl, true);
            //3rd param is set true since the otp is validated at backend first
            this.handleRedirection(appState.AuthCode.redirecturi, props, true);

        } else if (appState.AuthCode.result.status === 400) {
            window
                .location
                .replace(appState.AuthCode.redirecturi)
        } else {          
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['invalid_credentials']), "error", false);
            this.props.setState({loginError: 'invalid_credentials'});
        }
    }

    onSamlLoginChange() {
        let appState = LoginStore.getState();
        if (appState.SamlResponse.result == "Authenticated") {
            window.location.replace(appState.SamlResponse.redirecturi);
        } else if (appState.SamlResponse.result == "Non Authenticated") {
            if (appState.SamlResponse.message == "0201009" || appState.SamlResponse.message == "0201002") {
                var errorCode = ErrorCodes[appState.SamlResponse.message] + '_' + this.props.userType + '_' + this.props.countryCode;
                var messageKey = ErrorCodes[appState.SamlResponse.message];
                var title = null;

                if (LocaleUtils.isTranslationIdAvailable(this.props.intl, defaultMessages, errorCode)) {
                    messageKey = errorCode;
                    title = appState.SamlResponse.message == "0201009" && this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.SamlResponse.message]]);
                }
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[messageKey]), 'error', false, title);
            }
            else
                LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages[ErrorCodes[appState.SamlResponse.message]]), "error");

            this.props.setState({loginError: appState.SamlResponse.message});
        }
        else if (appState.SamlResponse.redirecturi != null) {
            window.location.replace(appState.SamlResponse.redirecturi)
        }
        else {
            LoginActions.triggerToast(this.props.intl.formatMessage(defaultMessages['invalid_credentials']), "error");
            this.props.setState({loginError: 'invalid_credentials'});
        }
    }

    handleRedirection(redirecturi, props, isOTPValid) {
        // to support 1FA and 2FA we extract the id_token from the redirect uri and then
        // check the value of two factor authentication flag
        let appState = LoginStore.getState();
        const userMFAMethods = appState.userMFAMethods;
        let idToken = UrlUtils.getHashParameterbyName('id_token', redirecturi);
        let parsed_token = Utils.tryParseToken(idToken);
        let error_desc = UrlUtils.getHashParameterbyName('error_description', redirecturi);
        const twoFaAuthMethod = !isNil(userMFAMethods) && userMFAMethods.length > 0 ? 
            LoginHelper.setAuthenticationMethod(userMFAMethods).authenticationMethod : LoginHelper.getAuthMethod(parsed_token);
        if ((isOTPValid && props.clientId == OAuthClientConfig.client_id['emp']) || (error_desc != '' && error_desc.startsWith(AppConstants.LoginPreferences.AUTH_METHOD_MISMATCH_ERROR_DESC) && parsed_token)) {
            window.location.replace(this.formLoginPreferenceUrl(idToken, props));
            return;
        }
        else if (error_desc != '' || !parsed_token || !twoFaAuthMethod) {
            LoginHelper.isFirstLogin(parsed_token)
                ? this.props.setState({showAnnouncement: true, parsedToken: parsed_token})
                : window
                    .location
                    .replace(redirecturi);
            return;
        }  
        
        this.props.setState({showTOTPControl: twoFaAuthMethod, phone: parsed_token.phone,idToken:idToken, emailId: parsed_token.email, userId: parsed_token.sub});
    }

    formLoginPreferenceUrl (idToken, props) {

        let loginPrefUrl = window.location.protocol + "//" + window.location.host + AppConstants.Links.LOGIN_PREFERENCES 
                    + "?" +
                    AppConstants.UrlParams.CLIENT_ID + "=" + props.clientId +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.REALM_ID, props.realmId) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.USER_TYPE, props.userType) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.COUNTRY_CODE, props.countryCode) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.LOCALE_ID, props.localeId) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.REDIRECT_URI, props.redirectUrl) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.TRACE_ID, props.traceId) +
                    UrlUtils.appendQueryParam(AppConstants.UrlParams.ID_TOKEN, idToken) 

                
        return loginPrefUrl;
    }

    render() {
        return <div></div>
    }
}

module.exports = LoginHandler;